import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=603d5054&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('603d5054')) {
      api.createRecord('603d5054', component.options)
    } else {
      api.reload('603d5054', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=603d5054&", function () {
      api.rerender('603d5054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/rentalBranches/Index.vue"
export default component.exports